<template lang="pug">
  .component-backoffice-category-list
    .row
      .columns.large-offset-11.text-right
        common-cost-button-modal(@itemUpdated="itemUpdated")
    .row.column
      base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="true", ref="list")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'
  import CommonCostButtonModal from "../../components/structure/ui/actions/CommonCostButtonModal";

  export default {
    name: 'CommonCostList',
    components: {
      BaseList,
      CommonCostButtonModal
    },
    data: function () {
      return {
        component: require('src/components/backoffice/CommonCost.vue'),
      }
    },
    created() {
    },
    methods: {
      dataLoader(callback, page = 1, resultsPerPage = 5) {
        KeplerBackofficeSdk.commonCosts.list().all(page, resultsPerPage, (data) => {
          callback(data)
        })
      },
      itemUpdated(op) {
        if(op === 'added') {
          this.$refs.list.loadData(1)
        }
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CommonCostList.vue?24e6a1f7